export default __webpack_public_path__ + "static/media/p2_token.6af9bf2e.png";